import { render, staticRenderFns } from "./BindingDialog.vue?vue&type=template&id=64d74506&scoped=true&"
import script from "./BindingDialog.vue?vue&type=script&lang=js&"
export * from "./BindingDialog.vue?vue&type=script&lang=js&"
import style0 from "./BindingDialog.vue?vue&type=style&index=0&id=64d74506&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d74506",
  null
  
)

export default component.exports